export default __webpack_public_path__ + "static/media/2026_Davis_et_al_2026_EcologyLetters.248236cb.pdf";